import { ColDef } from '@ag-grid-community/core';
import { CASCADE_ENUM } from '../../../services/enum.service';
import { getFormattedDate } from '../../../utils/formatting';
import { ThirdParty } from './third-party';

const defaultColumnConfig: ColDef = {
  enableCellChangeFlash: true,
  enableRowGroup: true,
  enablePivot: true,
  enableValue: true,
};

export function ThirdPartyColumnConfig(context: ThirdParty): ColDef[] {
  return [
    {
      ...defaultColumnConfig,
      field: 'USER_NAME',
      headerName: 'Username',
      minWidth: 120,
    },
    {
      ...defaultColumnConfig,
      field: 'FIRST_NAME',
      headerName: 'First Name',
      minWidth: 120,
    },
    {
      ...defaultColumnConfig,
      field: 'LAST_NAME',
      headerName: 'Last Name',
      minWidth: 120,
    },
    {
      ...defaultColumnConfig,
      field: 'RESURETY_REMAP_VERSION',
      headerName: 'REsurety Subscription Level',
      minWidth: 120,
      valueGetter: (params) =>
        context.enumService.getEnumTranslation(
          CASCADE_ENUM.RESURETY_REMAP_VERSION,
          params.data.RESURETY_REMAP_VERSION
        ),
    },
    {
      ...defaultColumnConfig,
      field: 'RESURETY_REMAP_TRIAL_STATUS',
      headerName: 'REsurety Trial Status',
      minWidth: 120,
      valueGetter: (params) =>
        context.enumService.getEnumTranslation(
          CASCADE_ENUM.RESURETY_REMAP_TRIAL_STATUS,
          params.data.RESURETY_REMAP_TRIAL_STATUS
        ),
    },
    {
      ...defaultColumnConfig,
      field: 'RESURETY_REMAP_TRIAL_END_DATE',
      headerName: 'REsurety Trial End Date',
      minWidth: 120,
      valueFormatter: (params) => getFormattedDate(params.data.RESURETY_REMAP_TRIAL_END_DATE),
    },
    {
      ...defaultColumnConfig,
      field: 'USER_UUID',
      headerName: 'Arteria ID',
      minWidth: 120,
      flex: 1,
    },
  ];
}
